import { Card, Table, Badge } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { SellerSummaryItem } from "../../types/Indicators.types"

interface SellerRankingProps {
  data: SellerSummaryItem[]
}

function formatMoney(value: number): string {
  return value.toLocaleString("en-US", { style: "currency", currency: "DOP", minimumFractionDigits: 0, maximumFractionDigits: 0 })
}

export default function SellerRanking({ data }: SellerRankingProps) {
  const { t } = useTranslation("global")

  return (
    <Card className="shadow-sm border-0">
      <Card.Header className="bg-white border-bottom">
        <h6 className="mb-0">
          <i className="fas fa-trophy me-2 text-warning" />
          {t("Seller Ranking")}
        </h6>
      </Card.Header>
      <Card.Body className="p-0">
        <Table hover responsive className="mb-0">
          <thead className="table-light">
            <tr>
              <th className="ps-3">#</th>
              <th>{t("Seller")}</th>
              <th className="text-end">{t("Total Sales")}</th>
              <th className="text-end">{t("Invoices")}</th>
              <th className="text-end">{t("Average Ticket")}</th>
              <th className="text-end">{t("Quotes")}</th>
              <th className="text-center">{t("Conversion Rate")}</th>
              <th className="text-end pe-3">{t("Unpaid Invoices")}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((seller, i) => (
              <tr key={seller.vendedorId}>
                <td className="ps-3">
                  {i < 3 ? (
                    <Badge bg={i === 0 ? "warning" : i === 1 ? "secondary" : "danger"} className="text-white">
                      {i + 1}
                    </Badge>
                  ) : (
                    <span className="text-muted">{i + 1}</span>
                  )}
                </td>
                <td className="fw-semibold">{seller.nombre}</td>
                <td className="text-end">{formatMoney(seller.totalSales)}</td>
                <td className="text-end">{seller.invoiceCount}</td>
                <td className="text-end">{formatMoney(seller.avgTicket)}</td>
                <td className="text-end">{seller.quoteCount}</td>
                <td className="text-center">
                  <Badge bg={seller.conversionRate >= 50 ? "success" : seller.conversionRate >= 25 ? "warning" : "danger"}>
                    {seller.conversionRate}%
                  </Badge>
                </td>
                <td className="text-end pe-3">
                  {seller.unpaidCount > 0 ? (
                    <span className="text-danger">{formatMoney(seller.unpaidAmount)} ({seller.unpaidCount})</span>
                  ) : (
                    <span className="text-success">-</span>
                  )}
                </td>
              </tr>
            ))}
            {data.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center text-muted py-4">{t("No data available")}</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  )
}
